import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MachineService } from "@services/machine.service";
import { ToastService } from "angular-toastify";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "employeeOverview",
	styleUrls: ["employeeOverview.css"],
	templateUrl: "employeeOverview.html"
})
export class EmployeeOverviewComponent {
	employees: any[] = [];
	isLoading = false;
	lastRefresh = "";
	siteId = 0;

	constructor(private route: ActivatedRoute, private toastService: ToastService, private machineService: MachineService) {
		this.route.params.subscribe((params) => {
			this.siteId = params.id;
			this.isLoading = true;
			this.getData();
			setTimeout(() => {
				this.isLoading = false;
			}, 2000);
		});

		setInterval(() => {
			this.getData();
		}, 5000);
	}

	getData() {
		this.machineService.app_OpsPlannerForSite(this.siteId)
			.subscribe(
				(res: any) => {
					const machines: any[] = res.response;
					const employeeMap: { [key: number]: any } = {};

					machines.forEach(machine => {
						machine.runningStages.forEach((stage: any) => {
							if (stage.assignedUserProfileId) {
								const id = stage.assignedUserProfileId;
								if (!employeeMap[id]) {
									employeeMap[id] = {
										clientName: stage.clientName,
										fullName: stage.assignedUserProfileFullName,
										id,
										machineName: machine.cellNumber,
										operationNumber: stage.operationNumber,
										partNumber: stage.partNumber,
										profileImage: stage.assignedUserProfileImage || null,
										quantityCompleted: stage.quantityCompleted,
										quantityRequired: stage.quantityRequired,
										workOrderId: stage.workOrderId,
									};
								}
							}
						});
					});

					this.employees = Object.values(employeeMap).sort((a, b) =>
						(a.fullName || "").localeCompare(b.fullName || "")
					);

					this.lastRefresh = new Date().toLocaleString();
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}

	get halfCount(): number {
		return Math.ceil(this.employees.length / 2);
	}

	getInitials(fullName: string): string {
		if (!fullName) { return "?"; }
		const parts = fullName.trim().split(" ");
		if (parts.length === 1) { return parts[0].substring(0, 1).toUpperCase(); }
		return (parts[0].substring(0, 1) + parts[parts.length - 1].substring(0, 1)).toUpperCase();
	}
}
